import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { MdaiLink } from "../../components/MdaiLink";
import { CdnImage } from "../../components/common/CdnImage";
import type { HomePageTemplate } from "../../types/homePageTemplate";
import homeData from "../../data/pages/home.json";
import { resolveAssetUrl } from "../../utils/resolveAssetUrl";

const typedHomeData = homeData as HomePageTemplate;

export const Solutions = () => {
  return (
    <Stack gap={8} flexDirection={"column"} alignItems={"center"} mb={5}>
      <Stack
        gap={{ sm: 3, lg: 4 }}
        alignItems={{ sm: "flex-start", lg: "center" }}
        width={"100%"}
      >
        {typedHomeData.solutions.map(
          ({ solution, title, description, img, imgAlt, href }, index) => (
            <Stack
              key={solution}
              direction={{ sm: "column", lg: "row" }}
              gap={8}
              alignItems={"center"}
              justifyContent={"center"}
              width="100%"
              py={{ sm: 2.5, lg: 5 }}
            >
              <CdnImage
                sx={{
                  height: "100%",
                  width: "100%",
                  maxWidth: "300px",
                  order: { lg: index % 2 === 0 ? 2 : 0 },
                }}
                alt={imgAlt}
                src={resolveAssetUrl(img)}
              />
              <Stack
                gap={{ sm: 3, lg: 2 }}
                alignItems={{ sm: "center", lg: "flex-start" }}
                maxWidth={"642px"}
                textAlign={{ sm: "center", lg: "left" }}
              >
                <Typography
                  display={{ sm: "none", lg: "initial" }}
                  variant="subtitle2"
                  fontWeight={600}
                >
                  {solution}
                </Typography>
                <Typography variant="h3">{title}</Typography>
                <Typography variant="subtitle2">{description}</Typography>
                <MdaiLink
                  variant="contained"
                  data-early-access="early_access"
                  href={href}
                  label="Learn more"
                  style={{ marginTop: "8px" }}
                  type="button"
                />
              </Stack>
            </Stack>
          ),
        )}
      </Stack>
    </Stack>
  );
};
